export const VIDEO_PROCESSING_LONG_RUNNING_SECONDS = 45;
export const VIDEO_PROCESSING_VERY_LONG_RUNNING_SECONDS = 180;
export const VIDEO_PROCESSING_RUNTIME_LIMIT_SECONDS = 900;

export function formatVideoProcessingElapsedLabel(totalSeconds = 0) {
	const safeSeconds = Math.max(0, Math.floor(Number(totalSeconds) || 0));
	const hours = Math.floor(safeSeconds / 3600);
	const minutes = Math.floor((safeSeconds % 3600) / 60);
	const seconds = safeSeconds % 60;
	if (hours > 0) {
		return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
	}
	return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

function formatVideoProcessingStartedAtLabel(startedAt = 0) {
	const safeStartedAt = Number(startedAt) || 0;
	if (!safeStartedAt) {
		return "";
	}

	try {
		return new Date(safeStartedAt).toLocaleTimeString([], {
			hour: "numeric",
			minute: "2-digit"
		});
	} catch (error) {
		return "";
	}
}

export function getVideoProcessingStatusFeedback(processingInfo = null, nowMs = Date.now()) {
	if (!processingInfo || typeof processingInfo !== "object") {
		return null;
	}

	const queueStatus = `${processingInfo.queueStatus || ""}`.trim().toLowerCase();
	const startedAt = Number(processingInfo.startedAt) || 0;
	const elapsedSeconds = startedAt > 0
		? Math.max(0, Math.floor(((Number(nowMs) || Date.now()) - startedAt) / 1000))
		: 0;
	const elapsedLabel = formatVideoProcessingElapsedLabel(elapsedSeconds);
	const startedLabel = formatVideoProcessingStartedAtLabel(startedAt);
	const runtimeLimitMinutes = Math.round(VIDEO_PROCESSING_RUNTIME_LIMIT_SECONDS / 60);

	let progressHint = "AmbiFi checks for the finished playback file automatically every few seconds.";
	let autoCheckLabel = "Auto-checking every few seconds";
	if (queueStatus === "preparing") {
		progressHint = "Preparing this video edit and adding it to the processing queue.";
		autoCheckLabel = "Queue request in progress";
	} else if (elapsedSeconds >= VIDEO_PROCESSING_VERY_LONG_RUNNING_SECONDS) {
		progressHint = `Still converting on the server. Blur-fill, reframing, HDR, resizing, and thumbnail generation can take several minutes. The current backend job can run for up to about ${runtimeLimitMinutes} minutes.`;
	} else if (elapsedSeconds >= VIDEO_PROCESSING_LONG_RUNNING_SECONDS) {
		progressHint = "Still converting on the server. Blur-fill, reframing, HDR, resizing, and thumbnail generation can take a few minutes.";
	}

	return {
		elapsedSeconds,
		elapsedLabel,
		startedLabel,
		runtimeLimitMinutes,
		progressHint,
		autoCheckLabel,
		sourceLabel: `${processingInfo.sourceFileName || processingInfo.name || ""}`.trim()
	};
}
